module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-event-item linked-item"
  }, [_vm._m(0), _c('div', {
    staticClass: "contact-event-header"
  }, [_c('div', {
    staticClass: "contact-event-title"
  }, [_vm._v(_vm._s(_vm.event.title))]), _c('div', {
    staticClass: "contact-event-description"
  }, [_c('span', [_vm._v("- " + _vm._s(_vm.event.description))]), (_vm.event.metadata && _vm.event.metadata.step && _vm.event.metadata.flow_name && _vm.event.metadata.flow_id) ? _c('span', {
    staticClass: "flow-description"
  }, [_c('span', {
    staticClass: "spaced"
  }, [_vm._v("-")]), _c('strong', {
    staticClass: "spaced"
  }, [_vm._v(_vm._s(_vm.event.metadata.step))]), _c('strong', {
    staticClass: "spaced"
  }, [_vm._v("Fluxo:")]), _c('router-link', {
    staticClass: "spaced underlined flow-link",
    attrs: {
      "to": '/fluxos-de-cadencia/' + _vm.event.metadata.flow_id
    }
  }, [_vm._v(_vm._s(_vm.event.metadata.flow_name))])], 1) : _vm._e()]), _c('div', {
    staticClass: "clear"
  }), _c('div', {
    staticClass: "contact-event-time"
  }, [_vm._v(_vm._s(_vm.event.created_at.format('LLL')))])]), _c('div', {
    staticClass: "clear"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-event-icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/icons/trash-bin.svg"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-49d50ad8!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/events/task_destroyed_event.vue
// module id = 1098
// module chunks = 1